import './ClinicSelect.css';
import * as React from 'react';
import { Component } from 'react';
import { IClinicListItem } from '../../models/IClinicListItem';
import { ClinicService } from '../../services/ClinicService';

interface IProps {
    OnSelect: (selectedId: number) => void,
    Placeholder?: string
}

interface IState {
    DropDownOpen: boolean,
    DropDownItems: IClinicListItem[],
    SelectedId?: number,
    SelectedItem?: IClinicListItem,
    SearchValue: string
}

export class ClinicSelectComponent extends Component<IProps, IState> {
    private DataRefreshTimeout: any;
    private SelectContainerNode: Node | null;
    private InputNode: Node | null;

    constructor(props) {
        super(props);

        this.state = {
            DropDownOpen: false,
            DropDownItems: [],
            SelectedId: undefined,
            SelectedItem: undefined,
            SearchValue: ''
        }

        this.OnInputChange = this.OnInputChange.bind(this);
        this.OnSearchSuccess = this.OnSearchSuccess.bind(this);
        this.OnSearchError = this.OnSearchError.bind(this);
        this.ShowDropDown = this.ShowDropDown.bind(this);
        this.HideDropDown = this.HideDropDown.bind(this);
        this.HideDropDownTimeout = this.HideDropDownTimeout.bind(this);
        this.OnDropDownItemClick = this.OnDropDownItemClick.bind(this);
        this.OnSelectClick = this.OnSelectClick.bind(this);
        this.HandleClickOutside = this.HandleClickOutside.bind(this);
    }

    public componentWillMount() {
        document.addEventListener('click', this.HandleClickOutside, false);
    }

    public componentWillUnmount() {
        document.removeEventListener('click', this.HandleClickOutside, false);
    }

    public render() {
        return (
            <div className="clinic-select-component select-container input"
                ref={node => this.SelectContainerNode = node}
                tabIndex={-1}>
                <input type="text"
                    className="form-control"
                    ref={node => this.InputNode = node}
                    placeholder={this.props.Placeholder ? this.props.Placeholder : ''}
                    value={this.state.SearchValue}
                    onChange={this.OnInputChange}
                    onFocus={this.ShowDropDown}
                    onBlur={this.HideDropDown} />
                {this.RenderDropDown()}
            </div>
        );
    }

    //private RenderSelectedItem() {
    //    if (this.state.SelectedItem == null) {
    //        return (
    //            <label>Wybierz klinikę</label>
    //        );
    //    } else {
    //        return (
    //            <Row className="selected-item">
    //                <Col xs={8} md={4}>
    //                    <span className="short-name">{this.state.SelectedItem.ShortName}</span>
    //                    <span className="full-name">{this.state.SelectedItem.FullName}</span>
    //                    <span className="full-address">{this.state.SelectedItem.FullAddress}</span>
    //                </Col>
    //                <Col xs={3} md={2}>
    //                    <button className="btn btn-default" onClick={this.OnSelectClick}>Wybierz miejsce pracy</button>
    //                </Col>
    //            </Row>
    //        );
    //    }
    //}

    private RenderDropDown() {
        if (this.state.DropDownOpen) {
            return (
                <div className="drop-down-container">
                    {this.RenderDropDownItems()}
                </div>
            );
        } else {
            return null;
        }
    }

    private RenderDropDownItems() {
        if (this.state.DropDownItems === undefined) {
            return (
                <li key="null">Wyszukaj</li>
            );
        } else {
            if (this.state.DropDownItems.length === 0) {
                return (
                    <li key="null">Wyszukaj</li>
                );
            } else {
                return (
                    this.state.DropDownItems.map((item) => (
                        <li key={item.Id} onClick={this.OnDropDownItemClick.bind(this, item.Id)}>
                            <span className="short-name">{item.ShortName}</span>
                            <span className="full-name">{item.FullName}</span>
                            <span className="full-address">{item.FullAddress}</span>
                        </li>
                    ))
                );
            }
        }
    }

    private OnDropDownItemClick(itemId: number, evt) {
        const selectedItem = this.state.DropDownItems.find(x => x.Id === itemId);
        this.setState({
            DropDownOpen: false,
            SelectedId: itemId,
            SelectedItem: selectedItem,
            DropDownItems: []
        });
        this.props.OnSelect(itemId);
    }

    private OnInputChange(e) {
        //this.setState({
        //    SearchValue: e.target.value
        //});
        //const val = e.target.value;
        //setTimeout((v) => {
        //    let service = new ClinicService();
        //    service.SearchClinics(v, this.OnSearchSuccess, this.OnSearchError);
        //}, 200, val);
        //Problematyczne jest to, że z każdym znakiem idzie nowy request. To trzeba by poprawić. Powinien iść tylko jeden request pod koniec pisania.

        this.setState({
            SearchValue: e.target.value
        });
        if (this.DataRefreshTimeout) {
            clearTimeout(this.DataRefreshTimeout);
            this.DataRefreshTimeout = undefined;
        }
        this.DataRefreshTimeout = setTimeout((t, searchVal) => {
            let service = new ClinicService();
            service.SearchClinics(searchVal, t.OnSearchSuccess, t.OnSearchError);
            clearTimeout(t.dataRefreshTimeout);
        }, 350, this, e.target.value);
    }

    private OnSearchSuccess(result) {
        this.setState({
            DropDownItems: result.data.Value
        });
    }

    private OnSearchError(error) {
        console.error(error);
    }

    private OnSelectClick(e) {
        if (this.state.SelectedId !== undefined) {
            this.props.OnSelect(this.state.SelectedId);
        }
    }

    private ShowDropDown(e) {
        this.setState({
            DropDownOpen: true
        });
    }

    private HideDropDown(e) {
        setTimeout(this.HideDropDownTimeout, 150);
    }

    private HideDropDownTimeout() {
        this.setState({
            DropDownOpen: false
        });
    }

    private HandleClickOutside(e: MouseEvent) {
        if (this.SelectContainerNode !== null && this.InputNode !== null) {
            if (this.SelectContainerNode.contains(e.target as HTMLElement)) {
                if (this.InputNode.isEqualNode(e.target as Node)) {
                    this.setState({
                        DropDownOpen: true
                    });
                } else {
                    this.setState({
                        DropDownOpen: true
                    });
                }
            } else {
                this.setState({
                    DropDownOpen: false
                });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Clinic/ClinicSelect.tsx